import { IconButton } from '@eventbrite/marmalade';
import { useIsMobile } from '../_shared/useIsMobile';

import { Cross as CrossIcon } from '@/components/_shared/Icons';

import styles from './MobilePopupLayout.module.scss';
import { ScrollableDrawer } from '@/components/_shared/ScrollableDrawer/ScrollableDrawer';

interface Props {
  opened: boolean;
  children: React.ReactElement;
  onClose?: () => void;
}

export const MobilePopupLayout: React.FC<Props> = ({ opened, onClose, children }) => {
  const isMobile = useIsMobile();

  return (
    <>
      {children}
      {isMobile && opened && (
        <ScrollableDrawer onClickOutside={onClose}>
          {({ closeDrawer }) => (
            <div className={styles.container}>
              <div className={styles.header}>
                <IconButton
                  className={styles.closeButton}
                  icon={<CrossIcon viewBox="0 0 25 25" fillColor="black" />}
                  aria-label="Close"
                  onClick={closeDrawer}
                  variant="onLightBackground"
                />
              </div>
              {children}
            </div>
          )}
        </ScrollableDrawer>
      )}
    </>
  );
};
